import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router/index.js'

Vue.config.productionTip = false

new Vue({
  i18n,
  router: router,
  render: h => h(App)
}).$mount('#app')

// Vue.use(VueAnalytics, {
//   id: 'G-PDPEPMKC0H',
//   router
// })